/* FWF swag kits: keeps one free swag kit in the cart for every copy of a book that has one. */
(function () {
  'use strict';
  var PROP = '_fwf_swag_for';
  var KIT_TYPE = 'Swag Kit';
  var MARK = 'fwf_swag=1';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var kitCache = {};
  var timer = null;
  var running = false;
  var rerun = false;
  var didChange = false;

  function url(path) { return root + path.replace(/^\//, ''); }
  function mark(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + MARK; }

  function post(path, body) {
    return nativeFetch(mark(url(path)), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return nativeFetch(mark(url('cart.js')), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function getKit(handle) {
    if (!kitCache[handle]) {
      kitCache[handle] = nativeFetch(url('products/' + encodeURIComponent(handle)) + '?view=fwf-swag-data', {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          try { return JSON.parse(t.trim()).kit || null; } catch (e) { return null; }
        })
        .catch(function () { return null; });
    }
    return kitCache[handle];
  }

  // Set a kit line's quantity; if there aren't enough kits left, give as many as possible.
  function setLine(key, qty) {
    return post('cart/change.js', { id: key, quantity: qty }).then(function (r) {
      if (r.ok) { didChange = true; return; }
      if (qty > 0) return setLine(key, qty - 1);
    });
  }

  function addKit(variant, bookId, qty) {
    if (qty <= 0) return Promise.resolve();
    var props = {};
    props[PROP] = String(bookId);
    return post('cart/add.js', { items: [{ id: variant, quantity: qty, properties: props }] }).then(function (r) {
      if (r.ok) { didChange = true; return; }
      return addKit(variant, bookId, qty - 1);
    });
  }

  function refreshUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    return getCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    });
  }

  function sync() {
    if (running) { rerun = true; return Promise.resolve(); }
    running = true;
    didChange = false;

    return getCart()
      .then(function (cart) {
        var books = {};
        var kitLines = [];

        cart.items.forEach(function (item) {
          var forId = item.properties && item.properties[PROP];
          if (forId || item.product_type === KIT_TYPE) { kitLines.push(item); return; }
          var b = books[item.product_id] || (books[item.product_id] = { handle: item.handle, qty: 0 });
          b.qty += item.quantity;
        });

        var ids = Object.keys(books);
        return Promise.all(ids.map(function (id) { return getKit(books[id].handle); })).then(function (kits) {
          var want = {};
          ids.forEach(function (id, i) {
            var kit = kits[i];
            if (kit && kit.available && kit.variant_id) {
              want[kit.variant_id + '|' + id] = { variant: kit.variant_id, bookId: id, qty: books[id].qty, seen: false };
            }
          });

          var steps = [];
          kitLines.forEach(function (line) {
            var key = line.variant_id + '|' + String((line.properties || {})[PROP] || '');
            var w = want[key];
            if (w && !w.seen) {
              w.seen = true;
              if (line.quantity !== w.qty) steps.push(function () { return setLine(line.key, w.qty); });
            } else {
              steps.push(function () { return setLine(line.key, 0); });
            }
          });
          Object.keys(want).forEach(function (k) {
            var w = want[k];
            if (!w.seen) steps.push(function () { return addKit(w.variant, w.bookId, w.qty); });
          });

          return steps.reduce(function (p, step) { return p.then(step); }, Promise.resolve());
        });
      })
      .then(function () { if (didChange) return refreshUI(); })
      .catch(function (e) { console.warn('FWF swag:', e); })
      .then(function () {
        running = false;
        if (rerun) { rerun = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  // Re-check after the theme (or anything else) changes the cart.
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var u = (input && input.url) || String(input);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(u) && u.indexOf(MARK) === -1) {
        p.then(function () { schedule(); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();